const equipmentRouter = [
    {
        path: "list-equipment",
        name: "equipment",
        component: () => import("@/views/admin/equipment/index.vue"),
        default: true,
        meta: {
            model: "equipment",
            // requiresAuth: true,
        },
    },
    {
        path: 'list-equipment/report',
        name: 'equipmentReport',
        component: () => import('@/views/admin/equipment/report/index'),
        meta: {
            model: 'report',
            // requiresAuth: true,
        }
    },
    {
        path: "list-equipment/add",
        name: "addEquipment",
        component: () => import("@/views/admin/equipment/function"),
        default: true,
        meta: {
            model: "equipment",
            // requiresAuth: true,
        },
    },
    {
        path: "list-equipment/edit/:id",
        name: "editEquipment",
        component: () => import("@/views/admin/equipment/function"),
        default: true,
        meta: {
            model: "equipment",
            // requiresAuth: true,
        },
    },
];
export default equipmentRouter;